import { Component, OnInit, TemplateRef, ViewChild, AfterContentInit } from '@angular/core';
import {
  LotService,
  LoaderService,
  AuctionService,
  WatchListService,
  WebStorageService,
} from '../../../../services';
import { Router, ActivatedRoute, Data } from '@angular/router';
import routeTable from '../../../../utility/routeTable';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../environments/environment';
import constants from '../../../../utility/constants';
import { FormControl, Validators } from '@angular/forms';
import { AppValidators } from '../../../../core/validators/app-validators';
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';
import { LotPublic, AuctionCurrentState } from '../../../../models';
import { BidService, BulkBid } from '../../../../services/bid.service';
import { interval, Subscription } from 'rxjs';
import { BidInfo } from '../../../shared/component/lot-card/lot-card.component';
import { AuctionTimeService } from '../../../../services/auction-time.service';

@Component({
  selector: 'app-view-lot',
  templateUrl: './view-lot.component.html',
  styleUrls: ['./view-lot.component.css'],
})
export class ViewLotComponent implements OnInit, AfterContentInit {
  modalRef: BsModalRef;
  lotId: number = null;
  loggedInUser = 0;
  auctionDetail: any;
  auctionId: any;
  currentSlider: any = [];
  showTimer: boolean = true;
  currentSliderHeader: string;
  timeDiff;
  sec;
  days = 0;
  config;
  events;
  formatted;
  hubUrl: string = environment.serverUrl + environment.hubs.bid;
  private subscriptions: Array<Subscription> = [];

  returnUrl: string = null;
  bidMinAmount: number = constants.common.bid.bidMinAmount;
  bidMaxAmount: number = constants.common.bid.bidMaxAmount;
  userFullName: string;
  auctionStatuses = constants.common.auctionStatus;
  errorMsg: string = null;
  isUserHighestBidder: boolean = false;
  biddingAmount: FormControl = new FormControl(null, [
    Validators.required,
    AppValidators.noWhitespace,
    AppValidators.onlyNumeric,
    Validators.min(this.bidMinAmount),
    Validators.max(this.bidMaxAmount),
  ]);
  private lotHubConnection: HubConnection;
  eachLotData: LotPublic;
  addedToWatchlist: number;

  lotNumber: string;
  soldStatuses = constants.common.soldStatus;

  isAddedToWatchlist: boolean = false;
  isLotClosed: boolean = false;
  @ViewChild('quickBidModal', { static: false })
  quickBidModal: TemplateRef<any>;
  viewLotHeader = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    dots: false,
    arrows: false,
    asNavFor: '.viewLotThumbs',
  };

  viewLotThumbs = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    dots: false,
    asNavFor: '.viewLotHeader',
    centerMode: true,
    centerPadding: '50px',
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  imagesSlider2 = {
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.view-more-slider .thumbs',
  };

  thumbnailsSlider2 = {
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    asNavFor: '.view-more-slider .image-slides2',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  auctionCode: string;
  auctionCurrentState: AuctionCurrentState;
  readOnlyCatalog: boolean;
  isLowConnectionMode: boolean = false;

  serverTimeSub: Subscription;
  lotType = constants.common.lotTypes;
  isQuickBidOrNot: boolean;
  changeInAmount: boolean = false;

  constructor(
    private auctionService: AuctionService,
    private loader: LoaderService,
    private lotService: LotService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private watchListService: WatchListService,
    private toastrService: ToastrService,
    private storage: WebStorageService,
    private bidService: BidService,
    private auctionTimer: AuctionTimeService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.lotNumber = params['lotId'];
      this.auctionCode = params['auctionCode'];
      this.bindDataToForm1();
    });
    this.route.queryParams.subscribe((queryParams) => {
      this.lotId = queryParams['lotId'];
    });
    var loggedInData = this.storage.getBuyer()?.loggedIn;
    if (loggedInData == true) {
      this.loggedInUser = this.storage.getBuyer()?.currentUser?.user?.id;
      this.userFullName =
        this.storage.getBuyer()?.currentUser?.user?.firstName +
        ' ' +
        this.storage.getBuyer()?.currentUser?.user?.lastName;
    }
    this.route.queryParams.subscribe((qParams) => {
      this.returnUrl = qParams['returnTo'];
    });

    this.route.data.subscribe((d: Data) => {
      this.auctionCurrentState = d['currentState'];
    });
  }

  ngAfterContentInit(): void {
    this.loadPrettyPhoto();
  }

  loadPrettyPhoto(): void {
    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    };
    waitForElm('.prettyPhotoSlideWrapperLotDetail').then((elm) => {
      //@ts-ignore
      $('a[rel^="prettyPhoto"]').prettyPhoto({
          animationSpeed: 'slow',
          theme: 'dark_rounded'
      });
    })
  }

  private initializeOnRouteChange() {
    this.lotId = null;
    this.loggedInUser = 0;
    this.showTimer = true;
    this.currentSlider = [];
    this.errorMsg = null;
    this.isUserHighestBidder = false;

    this.isAddedToWatchlist = false;
    this.isLotClosed = false;
    this.isLowConnectionMode = false;

    this.lotId = 0;

    let checkLotClosed = this.auctionTimer.isLotClosingBegun(
      this.eachLotData?.lotEndTimeUtc
    );

    var loggedInData = this.storage.getBuyer()?.loggedIn;

    if (loggedInData) {
      this.loggedInUser = this.storage.getBuyer()?.currentUser?.user?.id;
      this.checkLotConnectionMode();
    }

    if (
      this.loggedInUser > 0 &&
      this.eachLotData.loggedInUser?.isApproved &&
      (this.eachLotData.auction?.auctionStatus == this.auctionStatuses.past ||
        checkLotClosed) &&
      !this.readOnlyCatalog
    ) {
      this.showTimer = false;
      this.isLotClosed = true;
    }

    this.getResolverData();
  }

  private checkLotConnectionMode() {
    let storedValue = this.storage.getBuyer();
    if (storedValue)
      this.isLowConnectionMode = storedValue?.lotLowConnectionMode;
  }

  getResolverData() {
    this.route.data.subscribe((res) => {
      this.auctionCurrentState = res['auctionState'];
      if (
        !this.auctionCurrentState.isActive &&
        !this.auctionCurrentState.isApproved
      ) {
        this.checkAuctionDeactivated();
      }
      this.checkReadOnlyCatalog(this.auctionCurrentState);
    });
  }

  private checkAuctionDeactivated() {
    if (
      this.auctionCurrentState.isSentForApproval &&
      this.auctionCurrentState.status === this.auctionStatuses.pending
    ) {
      return;
    }
    if (!this.auctionCurrentState.saleType.isCatalogReadOnly) {
      this.toastrService.info(
        `Unfortunately ${this.auctionCode} is no longer available for bidding and you will be notified if and when the auction becomes available for bidding again`,
        constants.common.toast.infoTitle,
        constants.common.toast.config
      );
    }
    if (this.auctionCurrentState.saleType.isCatalogReadOnly) {
      this.toastrService.info(
        `Unfortunately ${this.auctionCode} is deactivated and you will be notified if and when the auction becomes available again`,
        constants.common.toast.infoTitle,
        constants.common.toast.config
      );
    }
    this.router.navigateByUrl('/');
  }

  private checkReadOnlyCatalog(auctionState: AuctionCurrentState) {
    this.readOnlyCatalog = auctionState.saleType.isCatalogReadOnly;
  }

  private checkBidding() {
    let checkLotClosed = this.auctionTimer.isLotClosingBegun(
      this.eachLotData?.lotEndTimeUtc
    );

    if (
      this.loggedInUser > 0 &&
      this.eachLotData.loggedInUser?.isApproved &&
      this.eachLotData.auction?.auctionStatus == this.auctionStatuses.live &&
      !this.readOnlyCatalog &&
      !checkLotClosed
    ) {
      this.lotHubConnection = new HubConnectionBuilder()
        .configureLogging(LogLevel.None)
        .withUrl(this.hubUrl)
        .withAutomaticReconnect()
        .build();

      this.registerHubEvents();
      this.lotHubConnection
        .start()
        .then(() => {
          this.getLotData();
        })
        .catch(() => {
          this.loader.showLoader(true);
        });
    } else {
      this.checkHigherBidder(this.eachLotData.highestBidder);
    }
  }

  private registerHubEvents() {
    this.lotHubConnection.onreconnecting(() => {
      this.loader.showLoader(true);
    });

    this.biddingListener();

    this.lotHubConnection.onreconnected(() => {
      this.getLotData();
    });
  }

  private getLotData() {
    this.loader.showLoader(true);
    let groupName: string =
      this.eachLotData.auction?.id + '#' + this.eachLotData?.id;
    this.lotHubConnection
      .invoke('AddUserToLotBidding', groupName)
      .then((response) => {
        if (response != null) {
          this.mapBidInfo(response);
        }
        this.loader.showLoader(false);
      })
      .catch(() => {
        this.loader.showLoader(false);
      });
    this.getServerCurrentDatetime();
  }

  getServerCurrentDatetime() {
    this.serverTimeSub = interval(10000).subscribe(() => {
      this.lotHubConnection.invoke('ServerCurrentDateTime').then((response) => {
        this.eachLotData.lotStartTimeUtc = response;
      });
    });
  }

  isTimeReached(isReached: boolean) {
    if (isReached) {
      this.getLotResults();
      this.showTimer = false;
      this.isLotClosed = true;
    }
  }

  private checkHigherBidder(highestBidders: Array<number> | null) {
    this.isUserHighestBidder = false;
    if (highestBidders != null) {
      let isHighest: number = highestBidders.find(
        (i) => i == this.eachLotData.loggedInUser?.userId
      );
      this.isUserHighestBidder = isHighest > -1 ? true : false;
    }
  }

  mapBidInfo(res: BidInfo, needToShowOutBidToast = false) {
    this.changeInAmount =
      +this.eachLotData.nextRequiredBid !== +res.nextRequiredBid;
    this.eachLotData.bidCount = res.bidCount;
    this.eachLotData.currentBid = res.currentBid;
    this.eachLotData.highestBid = res.highestBid;
    this.eachLotData.highestBidder = res.highestBidders;
    this.eachLotData.nextRequiredBid = res.nextRequiredBid;
    this.eachLotData.lotEndTimeUtc = res.lotEndTimeUtc;
    this.eachLotData.soldTo = res.soldTo;
    this.eachLotData.soldAt = res.soldAt;
    this.eachLotData.extendedByMinutes = res.extendedByMinutes;
    this.eachLotData.timeLeft = res.timeLeft;
    this.eachLotData.isBiddingPaused = res.isBiddingPaused;
    this.eachLotData.lotStatus = res.lotStatus;
    this.eachLotData.willSell = res?.willSell;
    this.eachLotData.loosers = res?.loosers;
    this.eachLotData.outbid = this.findOutbid(
      this.eachLotData
    );

    this.checkHigherBidder(res.highestBidders);

    this.isAddedToWatchlist = this.eachLotData.watchListId > 0 ? true : false;
  }

  private biddingListener() {
    this.lotHubConnection.on('GetLotByGroupName', (data: BidInfo) => {
      if (data != null) {
        this.mapBidInfo(data, true);
      }
    });
  }

  getViewLotDetail() {
    this.loader.showLoader(true);
    const lotDetail = this.lotService
      .getLotDetail(this.lotId, this.auctionCode, this.lotNumber)
      .subscribe(
        (res: any) => {
          this.eachLotData = res;
          this.lotId = this.eachLotData.id;
          this.initializeOnRouteChange();
          if (!this.isLowConnectionMode) {
            this.checkBidding();
          } else {
            this.checkHigherBidder(this.eachLotData.highestBidder);
          }
          this.currentSlider = res.images;
          this.eachLotData['outbid'] = this.findOutbid(this.eachLotData);
          this.isAddedToWatchlist =
            this.eachLotData.watchListId > 0 ? true : false;
          this.loader.showLoader(false);
        },
        () => {
          this.loader.showLoader(false);
          this.goBack();
        }
      );
      this.subscriptions.push(lotDetail)
  }

  private bindDataToForm1() {
    this.loader.showLoader(true);
    const auctionDetailByCode = this.auctionService
      .getAuctionDetailByCode(this.auctionCode)
      .subscribe((res: any) => {
        this.auctionDetail = res;
        this.loader.showLoader(false);
        this.getViewLotDetail();
      });
      this.subscriptions.push(auctionDetailByCode)
  }

  goToLot(lotNumber: string) {
    this.router.navigate(
      [this.auctionCode, routeTable.public.auctionLot, lotNumber],
      {
        queryParamsHandling: 'preserve',
      }
    );
  }

  goBack() {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
    } else {
      this.router.navigate([this.auctionCode, routeTable.public.auctionLot]);
    }
  }

  goToRegister(auctionCode: number) {
    this.router.navigate([auctionCode, routeTable.public.auctionRegister], {
      queryParams: { returnTo: this.router.url },
    });
  }

  onSubmit(isQuickBid) {
    this.isQuickBidOrNot = isQuickBid;
    this.changeInAmount = false;
    //if (isQuickBid) {
    if (!this.biddingAmount.value && !this.isQuickBidOrNot) {
      return;
    } else {
      this.modalRef = this.modalService.show(this.quickBidModal, {
        class: 'custom-popup modal-dialog-centered',
        ignoreBackdropClick: true,
        keyboard: false,
      });
      this.modalRef.onHidden.subscribe(() => {
        this.changeInAmount = false;
      });
    }
  }

  closeReviewModal() {
    this.changeInAmount = false;
    this.modalRef.hide();
  }

  submitBidByApi(isQuickBid: boolean = false) {
    this.errorMsg = null;
    let bidAmount: number;

    if (!isQuickBid) {
      if (this.biddingAmount.invalid) return;
      bidAmount = +this.biddingAmount.value;
    } else {
      bidAmount = +this.eachLotData.nextRequiredBid;
    }

    this.loader.showLoader(true);
    let model: BulkBid = {
      auctionId: this.eachLotData.auction.id,
      lotAmount: [
        {
          lotId: this.eachLotData.id,
          amount: bidAmount,
        },
      ],
      userId: this.eachLotData.loggedInUser?.userId,
      paddleNumber: this.eachLotData.loggedInUser?.paddleNumber,
      proxyUserId: null,
    };
    this.bidService
      .submitPublicBulkBid(model)
      .toPromise()
      .then((res: any) => {
        res = res[0];
        this.loader.showLoader(false);
        if (res.isSuccess) {
          this.toastrService.success(
            res.message,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
          this.biddingAmount.reset();
        } else {
          this.errorMsg = res.message;
        }
        if (res.isDeactivated) {
          this.checkAuctionDeactivated();
        }
      })
      .catch((err) => {
        this.loader.showLoader(false);
        this.toastrService.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      });
    this.closeReviewModal();
  }

  private getLotResults() {
    this.loader.showLoader(true);
    const lotResult = this.bidService.getLotResult(this.eachLotData.id).subscribe(
      (res) => {
        this.loader.showLoader(false);
        this.mapBidInfo(res, true);
      },
      () => this.loader.showLoader(false)
    );
    this.subscriptions.push(lotResult)
  }

  openModalViewMore(
    template4: TemplateRef<any>,
    isSliderImages: boolean = false,
    picture
  ) {
    let photoArray = [];
    this.currentSlider = [];
    photoArray = this.eachLotData?.images;
    let index = photoArray.findIndex((x) => x.id == picture?.id);
    if (index > -1) {
      photoArray[index]['selected'] = true;
    }

    let arr = photoArray.filter((x) => x.id >= picture?.id);
    let arr1 = photoArray.filter((x) => x.id < picture?.id);
    Array.prototype.push.apply(this.currentSlider, arr);
    Array.prototype.push.apply(this.currentSlider, arr1);

    this.currentSliderHeader = 'Photo Gallery';
    this.modalRef = this.modalService.show(template4, this.config);
  }
  getHighlightedImage(image) {
    this.currentSlider.forEach((element) => {
      if (element.selected) {
        delete element.selected;
      }
    });
    image['selected'] = true;
    return image;
  }

  addToWatchList() {
    this.loader.showLoader(true);
    let model = {
      lotId: this.eachLotData.id,
      auctionId: this.auctionDetail.id,
    };
    const addwatchList = this.watchListService.addToWatchList(model).subscribe(() => {
      this.toastrService.success(
        `Lot # ${this.eachLotData.lotNumber} added to Watchlist`,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
      this.isAddedToWatchlist = true;
      this.loader.showLoader(false);
    });
    this.subscriptions.push(addwatchList)
  }

  removeFromWatchList() {
    this.loader.showLoader(true);
    let model = {
      lotId: this.eachLotData.id,
      auctionId: this.auctionDetail.id,
    };
    const removeWatchList = this.watchListService.removeFromWatchList(model).subscribe(() => {
      this.toastrService.success(
        `Lot # ${this.eachLotData.lotNumber} removed from Watchlist`,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
      this.isAddedToWatchlist = false;
      this.loader.showLoader(false);
    });
    this.subscriptions.push(removeWatchList)
  }

  findLooser(): number {
    if (this.eachLotData.loosers)
      return this.eachLotData.loosers?.findIndex(
        (i) => i == +this.loggedInUser
      );
  }

  findOutbid(item) {
    let index =
      item.loosers && item.loosers?.length > 0
        ? item.loosers?.findIndex((x) => x == this.loggedInUser)
        : -1;
    let index1 =
      item.highestBidder && item.highestBidder?.length > 0
        ? item.highestBidder?.findIndex((x) => x == this.loggedInUser)
        : -1;
    if (index > -1 && index1 == -1) {
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    if (this.serverTimeSub) this.serverTimeSub.unsubscribe();
    if (this.lotHubConnection) {
      this.lotHubConnection.stop();
    }
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
